import { isDefined } from "@clipboard-health/util-ts";

import { type ShiftSearchResult } from "../api/useSearchShift";
import { type SearchResultItem } from "../hooks/useOmnisearchResults";
import { type CopiedItemType } from "../OmnisearchResultsList";
import { SectionHeader } from "./SectionHeader";
import { ShiftActionItem } from "./ShiftActionItem";
import { ShiftResultItem } from "./ShiftResultItem";

interface ShiftSectionProps {
  shift: ShiftSearchResult;
  isShiftExpanded: boolean;
  hasTopMargin: boolean;
  shiftBaseIndex: number;
  selectedIndex: number;
  copiedItem: CopiedItemType | null;
  registerRef: (index: number) => (element: HTMLElement | null) => void;
  onSelect: (item: SearchResultItem) => void;
}

export function ShiftSection(props: ShiftSectionProps) {
  const {
    shift,
    isShiftExpanded,
    hasTopMargin,
    shiftBaseIndex,
    selectedIndex,
    copiedItem,
    registerRef,
    onSelect,
  } = props;

  const hasAgent = isDefined(shift.agent?.userId);
  const workplaceActionIndex = shiftBaseIndex + 1 + (hasAgent ? 1 : 0);

  return (
    <>
      <SectionHeader hasTopMargin={hasTopMargin} label="Shifts" />
      <ShiftResultItem
        ref={registerRef(shiftBaseIndex)}
        expanded={isShiftExpanded}
        selected={selectedIndex === shiftBaseIndex}
        shift={shift}
        onClick={() => {
          onSelect({ type: "shift", data: shift, expanded: isShiftExpanded });
        }}
      />
      {isShiftExpanded && hasAgent && (
        <ShiftActionItem
          ref={registerRef(shiftBaseIndex + 1)}
          action="worker"
          copied={copiedItem === "worker"}
          selected={selectedIndex === shiftBaseIndex + 1}
          shift={shift}
          onClick={() => {
            onSelect({ type: "shift-action", data: shift, action: "worker" });
          }}
        />
      )}
      {isShiftExpanded && isDefined(shift.facility?.userId) && (
        <ShiftActionItem
          ref={registerRef(workplaceActionIndex)}
          action="workplace"
          copied={copiedItem === "workplace"}
          selected={selectedIndex === workplaceActionIndex}
          shift={shift}
          onClick={() => {
            onSelect({ type: "shift-action", data: shift, action: "workplace" });
          }}
        />
      )}
    </>
  );
}
